/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-left': {
    width: 11,
    height: 18,
    viewBox: '0 0 11 18',
    data: '<path pid="0" _fill="#203F6A" d="M10.426 3.334c.765-.763.765-2 0-2.762a1.967 1.967 0 00-2.774 0L.574 7.619c-.765.763-.765 2 0 2.762l7.078 7.047a1.967 1.967 0 002.774 0c.765-.763.765-2 0-2.762L4.736 9l5.69-5.666z"/>'
  }
})
